import CheckBoxMultiCheck from "../../../Sections/ElementsSections/CheckBoxMultiCheck";
import { CheckData } from "../DialogInstallScriptsUpdate";
import dialogStyles from "./dialogStyles.module.css";
import React from "react";

interface Props {
  onEdit: (data: CheckData) => Promise<void>;
  label: string;
  CheckState: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function CheckBoxWithLabel({ label, onEdit, CheckState }: Props) {
  return (
    <div className={dialogStyles.checkBoxContainer}>
      <div>
        <CheckBoxMultiCheck onEdit={onEdit} CheckState={CheckState} />
      </div>
      <div className={dialogStyles.dialogDayTypelabel}>{label}</div>
    </div>
  );
}
